import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=131eef4c&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=ts"
export * from "./PageTitle.vue?vue&type=script&lang=ts"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=131eef4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131eef4c",
  null
  
)

export default component.exports